<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "FlashedMessageHandler",
        methods:{
            showFlashedMessages() {
                let should_display = !!this.$page?.flash?.success && !!this.$page?.flash?.message
                let success = this.$page?.flash?.success
                let message = this.$page?.flash?.message

                if (!should_display) {
                    return
                }

                setTimeout(() => {
                    if (success) {
                        this.$root.snackbar.success(message)
                    } else {
                        this.$root.snackbar.error(message)
                    }
                }, 1000)
            },
        },
        mounted () {
            this.showFlashedMessages()
        },
    }
</script>
